/*jshint esversion: 6 */
// import Vue from 'vue';
import axios from 'axios';
import {extractErrorDetails} from '@/helpers/util.js';

const initialState = () => ({
  loading: false,
  work_steps: [],
  pagination: {},
  new_custom_work_step: {
    text: "",
    country: {
      flag: '',
      name: 'Select country'
    },
    hashtags: []
  },
  error: ''
});

// State object
const state = initialState();
// Getter functions
const getters = {
  getWorkSteps: ( state ) => {
    return state.work_steps;
  },
  getPagination: (state) => state.pagination,
  getWorkStepById: ( state ) => (work_step_id) => {
    return state.work_steps.find(ws => ws.id = work_step_id);
  },
  getNewCustomWorkStep: ( state ) => {
    return state.new_custom_work_step;
  },
  isLoading: ( state ) => {
    return state.loading;
  }
};
// Actions
const actions = {
  createCompleteWorkStep({commit, getters}){
    commit('set_loading', true);
    return new Promise((resolve, reject) => {
      let stateWorkStep = getters.getNewCustomWorkStep;
      let work_step = {};
      work_step.text = stateWorkStep.text;
      work_step.country = stateWorkStep.country.flag;
      work_step.hashtags = stateWorkStep.hashtags;
      axios({
        url: 'worksteps',
        method: 'POST',
        data: work_step
      })
      .then(resp => {
        commit('add_work_step', resp.data.data);
        commit('reset_work_step_editor');
        commit('set_loading', false);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('set_loading', false);
        reject();
      });
    });
  },
  requestCustomWorkSteps({ commit }, page){
    return new Promise((resolve, reject) => {
      let offset = (page - 1 || 0) * 15;
      commit('set_loading', true);
      axios({
        url: 'worksteps?show=showForCustoms&offset=' + offset + '&limit=50',
        method: 'GET',
        headers: {'Cache-Control': 'no-cache'}
      })
      .then(resp => {
        commit('set_work_steps', resp.data.data);
        commit('set_work_steps_pagination', resp.data.meta_data);
        commit('set_loading', false);
        resolve();
      })
      .catch(err => {
        commit('set_error', extractErrorDetails(err));
        commit('set_loading', false);
        reject();
      });
    });
  },
  suggestToCommunity({commit}, work_step_id){
    axios({
      url: 'worksteps/' + work_step_id,
      method: 'PUT',
      data: {
        is_community_suggested: true
      }
    })
    .then(() => {
      commit('update_community_suggested', work_step_id);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  deleteWorkStep({commit}, work_step_id){
    axios({
      url: 'worksteps/' + work_step_id,
      method: 'DELETE'
    })
    .then(() => {
      commit('delete_work_step', work_step_id);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  updateWorkStep({commit}, payload){
    axios({
      url: 'worksteps/' + payload.work_step_id,
      method: 'PUT',
      data: payload.update
    })
    .then(() => {
      commit('update_work_step', payload);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  updateWorkStepHashtags({commit}, payload){
    axios({
      url: 'worksteps/' + payload.work_step_id + '/hashtags',
      method: 'PUT',
      data: payload.update
    })
    .then(resp => {
      commit('replace_work_step', resp.data.data);
    })
    .catch(err => {
      commit('set_error', extractErrorDetails(err));
    });
  },
  setNewCustomWorkStepText({commit}, payload){
    commit('set_new_custom_work_step_text', payload);
  },
  setNewCustomWorkStepCountry({commit}, payload){
    commit('set_new_custom_work_step_country', payload);
  },
  setNewCustomWorkStepHashtags( {commit}, payload){
    commit('set_new_custom_work_step_hashtags', payload);
  },
};
// Mutations
const mutations = {
  add_work_step(state, work_step) {
    state.work_steps = [...state.work_steps, work_step];
  },
  reset_work_step_editor(state){
    state.new_custom_work_step = {
      text: "",
      country: {
        flag: '',
        name: 'Select country'
      },
      hashtags: []
    };
  },
  replace_work_step(state, work_step){
    const index = state.work_steps.findIndex(function(item) {
      return item.id == work_step.id;
    });
    state.work_steps = [
      ...state.work_steps.slice(0, index),
      work_step,
      ...state.work_steps.slice(index + 1)
    ];
  },
  reset(state) {
    const newState = initialState();
    Object.keys(newState).forEach(key => {
      state[key] = newState[key];
    });
  },
  set_loading(state, loading) {
    state.loading = loading;
  },
  set_error(state, error) {
    state.error = error;
  },
  set_new_custom_work_step_text(state, text){
    state.new_custom_work_step.text = text;
  },
  set_new_custom_work_step_country(state, country){
    state.new_custom_work_step.country = country;
  },
  set_new_custom_work_step_hashtags(state, hashtags){
    state.new_custom_work_step.hashtags = [...hashtags];
  },
  set_work_steps(state, work_steps) {
    state.work_steps = [...work_steps];
  },
  set_work_steps_pagination(state, meta_data) {
    state.pagination = meta_data;
  },
  update_community_suggested(state, work_step_id){
    const index = state.work_steps.findIndex(function(item) {
      return item.id == work_step_id;
    });
    let work_step = state.work_steps[index];
    work_step.is_community_suggested = true;
    state.work_steps = [
      ...state.work_steps.slice(0, index),
      work_step,
      ...state.work_steps.slice(index + 1)
    ];
  },
  update_work_step(state, payload){
    const index = state.work_steps.findIndex(function(item) {
      return item.id == payload.work_step_id;
    });
    let work_step = state.work_steps[index];
    state.work_steps = [
      ...state.work_steps.slice(0, index),
      Object.assign(work_step, payload.update),
      ...state.work_steps.slice(index + 1)
    ];
  },
  delete_work_step(state, work_step_id){
    const index = state.work_steps.findIndex(function(item) {
      return item.id == work_step_id;
    });
    state.work_steps = [
      ...state.work_steps.slice(0, index),
      ...state.work_steps.slice(index + 1)
    ];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
